import { Component, input } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';

@Component({
  selector: 'app-group-payment-page-header-block',
  templateUrl: './group-payment-page-header-block.component.html',
  standalone: false,
})
export class GroupPaymentPageHeaderBlockComponent {
  textColor = input<IContentBuilderFieldColor>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  backgroundColor = input<IContentBuilderFieldColor>({
    value: '#FFFFFF',
    type: ColorFieldTypesValues.Hex,
  });

  constructor(private readonly location: LocationStrategy) {}

  back(): void {
    this.location.back();
  }
}
